// extracted by mini-css-extract-plugin
export default {"inputLabel":"Label-module__inputLabel__Y2qdlu2"};